"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Field = styled_components_1.default.fieldset `
  display: block;
  border: 1px solid #000;
  padding: 3px;

  -moz-border-radius: 5px;
  border-radius: 5px;
  -webkit-border-radius: 5px;

  > legend {
    text-align: left;
    padding: 3px;
  }
`;
//# sourceMappingURL=field.js.map